import { gql } from "@apollo/client"
import { useQuery, UseQueryOptions } from "@oysterhr/core"
import { Engagement } from "@oysterhr/schema"

const ENGAGEMENT_PAYOUT_PROVIDER = gql`
  query EngagementPayoutProvider(
    $engagementId: ID!
    $currencyCode: String!
    $countryCode: String!
  ) {
    engagement(engagementId: $engagementId) {
      id
      payoutProvider(currencyCode: $currencyCode, countryCode: $countryCode) {
        name
      }
    }
  }
`

type Result = {
  engagement: {
    payoutProvider: Pick<Engagement["payoutProvider"], "name">
  }
}
type Variables = {
  engagementId: string
  currencyCode: string
  countryCode: string
}

export const useEngagementPayoutProvider = (options: UseQueryOptions<Result, Variables>) =>
  useQuery<Result, Variables>(ENGAGEMENT_PAYOUT_PROVIDER, options)

useEngagementPayoutProvider.query = ENGAGEMENT_PAYOUT_PROVIDER
